module.exports = __webpack_public_path__ + "media/images/pt/concept_leadership-4aeeedc01b6d2973e820dfa8889694b3.png";